/**
 * 앱 1대 로그인 — 다른 기기가 쓰던 계정일 때 「이 기기로 로그인」 확인 (/m/login/switch)
 * ($j.Pages.Mobile.LoginSwitch / body data-page-name="LoginSwitch")
 */
export default class LoginSwitch {
    initialize() {
        $(function () {
            const $ok = $('#switch-confirm');
            const $cancel = $('#switch-cancel');

            function send(action) {
                $ok.prop('disabled', true).toggleClass('is-loading', action === 'confirm');
                $cancel.prop('disabled', true);
                $.post('/m/ajax/device/switch', { action: action })
                    .done(function (res) {
                        // 이 화면으로 되돌아오지 않게 replace (CLAUDE.md 페이지 이동)
                        location.replace((res && res.url) || '/m');
                    })
                    .fail(function () {
                        $ok.prop('disabled', false).removeClass('is-loading');
                        $cancel.prop('disabled', false);
                        $j.Common.Util.swalert('처리하지 못했어요.\n잠시 후 다시 시도해 주세요.');
                    });
            }

            $ok.on('click', function () { send('confirm'); });
            $cancel.on('click', function () { send('cancel'); });
        });

    }
}
